"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapPoint = exports.poleMeasurementAccuracyTypes = exports.TopologicalEditorPointCSS = void 0;
const theme_1 = require("../../../components/theme");
const theme_palette_1 = require("../../../components/theme.palette");
const dom_1 = require("../../../dom");
const i18n_1 = require("../../../i18n");
const mithril_1 = require("../../../mithril");
const classnames_1 = require("../../../util/classnames");
const CIRCLE_RADIUS = theme_1.DefaultTheme.spacingFactor * 1.5;
const CIRCLE_SIZE_PX = CIRCLE_RADIUS * 2 + 'px';
const CIRCLE_BORDER_SIZE = 2;
const CIRCLE_DOT_SIZE = 3;
const MAX_TITLE_WIDTH = 120;
exports.TopologicalEditorPointCSS = {
    container: 'c-TopologicalEditorMapPoint',
    titleContainer: 'c-TopologicalEditorMapPoint__titleContainer',
    title: 'c-TopologicalEditorMapPoint__title',
    isSelected: 'c-TopologicalEditorMapPoint--isSelected',
    locationFixed: 'c-TopologicalEditorMapPoint--fixed',
    locationEdited: 'c-TopologicalEditorMapPoint--edited',
    locationManualOrFloat: 'c-TopologicalEditorMapPoint--manualOrFloat',
    locationLow: 'c-TopologicalEditorMapPoint--low',
    locationDefault: 'c-TopologicalEditorMapPoint--default'
};
const PointStyles = {
    [exports.TopologicalEditorPointCSS.titleContainer]: {
        position: 'absolute',
        width: `${MAX_TITLE_WIDTH}px`,
        'justify-content': 'center'
    },
    [exports.TopologicalEditorPointCSS.title]: {
        background: `${(0, theme_1.rgba)(theme_palette_1.ColorPaletteBlue.C900, 0.5)}`,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        color: `${(0, theme_1.rgba)(theme_palette_1.WHITE)}`,
        padding: '4px',
        'z-index': '500'
    },
    [exports.TopologicalEditorPointCSS.container]: {
        height: CIRCLE_SIZE_PX,
        width: CIRCLE_SIZE_PX,
        minWidth: CIRCLE_SIZE_PX,
        maxWidth: CIRCLE_SIZE_PX,
        borderRadius: '50%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        background: theme_1.DefaultTheme.color.accent,
        border: `${CIRCLE_BORDER_SIZE}px solid ${(0, theme_1.rgba)(theme_palette_1.BLACK, 0.5)}`,
        cursor: 'pointer',
        transition: ['box-shadow'],
        transitionDuration: 150
    },
    [`${exports.TopologicalEditorPointCSS.container}.${exports.TopologicalEditorPointCSS.isSelected}`]: {
        boxShadow: `0 0 0 3px rgba(${theme_palette_1.ColorPaletteBlue.C700}, 0.24), 0 0 0 3px rgba(${theme_palette_1.ColorPaletteBlue.C700}, 0.64)`,
        border: `${CIRCLE_BORDER_SIZE}px solid rgba(255, 255, 255, 0.87)`
    },
    [`${exports.TopologicalEditorPointCSS.container}:hover, ${exports.TopologicalEditorPointCSS.container}.${exports.TopologicalEditorPointCSS.isSelected}:hover`]: {
        boxShadow: theme_1.DefaultTheme.shadow.box.dp2w5
    },
    [exports.TopologicalEditorPointCSS.locationFixed]: {
        backgroundColor: (0, theme_1.rgba)(theme_palette_1.ColorPaletteGreen.A700)
    },
    [`${exports.TopologicalEditorPointCSS.locationEdited}`]: {
        backgroundColor: (0, theme_1.rgba)(theme_palette_1.ColorPaletteGreen.A700),
        ['&::after']: {
            content: '""',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: `${CIRCLE_DOT_SIZE}px`,
            height: `${CIRCLE_DOT_SIZE}px`,
            borderRadius: '50%',
            backgroundColor: (0, theme_1.rgba)(theme_palette_1.BLACK)
        }
    },
    [exports.TopologicalEditorPointCSS.locationManualOrFloat]: {
        backgroundColor: (0, theme_1.rgba)(theme_palette_1.ColorPaletteYellow.C400)
    },
    [exports.TopologicalEditorPointCSS.locationLow]: {
        backgroundColor: (0, theme_1.rgba)(theme_palette_1.ColorPaletteRed.A700)
    },
    [exports.TopologicalEditorPointCSS.locationDefault]: {
        backgroundColor: theme_1.DefaultTheme.color.accent
    }
};
(0, theme_1.addStyles)(PointStyles);
exports.poleMeasurementAccuracyTypes = {
    rtk_fixed: exports.TopologicalEditorPointCSS.locationFixed,
    edited: exports.TopologicalEditorPointCSS.locationEdited,
    manual: exports.TopologicalEditorPointCSS.locationManualOrFloat,
    rtk_float: exports.TopologicalEditorPointCSS.locationManualOrFloat,
    low: exports.TopologicalEditorPointCSS.locationLow,
    default: exports.TopologicalEditorPointCSS.locationDefault
};
exports.MapPoint = {
    view({ summary, point, isCollectionSelected, poleAccuracy, onClick, onCollectionMouseOver, onCollectionMouseOut, showCollectionTitle, showTitlesOnMap }) {
        return [
            (0, mithril_1.m)('div', {
                key: summary.objectId,
                [dom_1.DRAGON_ID]: summary.revision,
                [dom_1.DRAGON_TYPE]: dom_1.DragonDomTypes.COLLECTION,
                className: (0, classnames_1.classNames)(exports.TopologicalEditorPointCSS.container, exports.poleMeasurementAccuracyTypes[poleAccuracy], {
                    [exports.TopologicalEditorPointCSS.isSelected]: isCollectionSelected
                }),
                onclick: onClick,
                style: {
                    top: (point.y - CIRCLE_RADIUS - CIRCLE_BORDER_SIZE) + 'px',
                    left: (point.x - CIRCLE_RADIUS - CIRCLE_BORDER_SIZE) + 'px'
                },
                onmouseover: onCollectionMouseOver,
                onmouseout: onCollectionMouseOut
            }),
            (0, mithril_1.m)('div', {
                className: exports.TopologicalEditorPointCSS.titleContainer,
                style: {
                    top: (point.y - (theme_1.DefaultTheme.spacingFactor * 9)) + 'px',
                    left: (point.x - (MAX_TITLE_WIDTH / 2)) + 'px',
                    display: showCollectionTitle || showTitlesOnMap ? 'flex' : 'none'
                }
            }, (0, mithril_1.m)('div', {
                className: exports.TopologicalEditorPointCSS.title
            }, summary.title || summary.subtitle || (0, i18n_1.Translate)(i18n_1.T.COLLECTION_MISSING_TITLE)))
        ];
    }
};
//# sourceMappingURL=map.point.js.map